//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import WasteCollectDrawer from "./modules/WasteCollectDrawer";
import WasteDealDrawer from "./modules/WasteDealDrawer";
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import { GetSiteIdMixin } from '@/mixins/GetSiteIdMixin';
import { queryUserTreeList as _queryUserTreeList } from '@/api/api';
import { getAction } from '@/api/manage';
export default {
  name: 'WasteCollectList',
  mixins: [JeecgListMixin, GetSiteIdMixin],
  components: {
    WasteCollectDrawer: WasteCollectDrawer,
    WasteDealDrawer: WasteDealDrawer
  },
  data: function data() {
    return {
      pagePath: '/om/waste/collect',
      pageTitle: '废液收集',
      addDisabled: false,
      userTree: [],
      // 表头
      isorter: {
        column: 'stime',
        order: 'desc'
      },
      siteColumn: {
        dataIndex: 'siteName',
        colName: 'site_id',
        title: '站点名称',
        align: 'center',
        sorter: true
      },
      columns: [{
        title: '序号',
        dataIndex: '',
        key: 'rowIndex',
        width: 60,
        align: 'center',
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        dataIndex: 'stime',
        colName: 'stime',
        title: '收集开始时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'etime',
        colName: 'etime',
        title: '收集结束时间',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'userId_userName',
        colName: 'user_id',
        title: '运维人员',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'quantity',
        colName: 'quantity',
        title: '废液总量（L）',
        align: 'center',
        sorter: true
      }, {
        dataIndex: 'deal_id',
        colName: 'dealId',
        title: '处置状态',
        align: 'center',
        sorter: true,
        customRender: function customRender(t, r, index) {
          if (r.dealId == null) {
            return '未处置';
          } else {
            return '已处置';
          }
        }
      }, {
        title: '操作',
        dataIndex: 'action',
        align: 'center',
        width: 120,
        scopedSlots: {
          customRender: 'action'
        }
      }]
    };
  },
  created: function created() {
    this.queryUserTreeList();
    this.queryParam.status = 1;
  },
  watch: {
    currentSiteId: function currentSiteId(value) {
      var ids = this.getTreeCurrentId();
      console.log(value);
      this.queryParam.scopeId = ids[1];
      this.queryParam.scope = ids[0];

      if (ids[0] == 1) {
        // 根据站点id
        this.addDisabled = false;
        this.queryParam.siteId = ids[1];
        this.spliceColumn(this.siteColumn);
      } else {
        // 根据区域id
        this.addDisabled = true;
        this.queryParam.siteId = undefined;
        this.spliceColumn(this.siteColumn, 1);
      }

      this.delayLoadData();
    }
  },
  computed: {},
  methods: {
    queryUserTreeList: function queryUserTreeList() {
      var _this = this;

      var that = this;
      that.userTree = []; // 用户

      _queryUserTreeList().then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            that.userTree.push(temp);
          }

          _this.loading = false;
        }
      });
    },
    handleAdd: function handleAdd() {
      var siteId = this.queryParam.siteId;
      this.$refs.modalForm.add(siteId);
      this.$refs.modalForm.title = '新增：' + this.pageTitle;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.showTab = false;
      this.$refs.modalForm.showContact = false;
    },
    // 新增/修改 成功时，重载列表
    modalFormOk: function modalFormOk() {
      var record = {};
      record.siteId = this.queryParam.siteId;
      this.queryParam = record;
      this.loadData();
    },
    batchDeal: function batchDeal() {
      var _this2 = this;

      if (this.selectedRowKeys.length <= 0) {
        this.$message_custom('请选择' + this.pageTitle + '记录！', 'warning');
        return;
      } else {
        var ids = '';

        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }

        getAction('/om/waste/collect/queryNoDealByIds' + '/' + ids).then(function (res) {
          if (res.success) {
            if (res.result.length < 1) {
              _this2.$message_custom('请选择' + _this2.pageTitle + '未处置记录！', 'warning');

              return;
            } else {
              var siteId = _this2.queryParam.siteId;

              _this2.$refs.dealForm.add(siteId, ids);

              _this2.$refs.dealForm.title = '新增：废液处置';
              _this2.$refs.dealForm.disableSubmit = false;
              _this2.$refs.dealForm.showTab = false;
              _this2.$refs.dealForm.showContact = false;
            }
          }
        });
      }
    },
    onDateStime: function onDateStime(value, dateArray) {
      this.queryParam.stimeStart = dateArray[0];
      this.queryParam.stimeEnd = dateArray[1];
    },
    onDateEtime: function onDateEtime(value, dateArray) {
      this.queryParam.etimeStart = dateArray[0];
      this.queryParam.etimeEnd = dateArray[1];
    },
    filterOption: function filterOption(input, option) {
      console.log('option', option.componentOptions.children[0].text);
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    }
  }
};